import { memo, useCallback } from 'react';
import { MenuItem, useDropdownMenu } from '@aimsos/ui';

/**
 * One entry of an "Imports as" menu. A target already used by another column is disabled and
 * says which one: `Used by "Work Email"`. Closes the parent menu once picked.
 *
 * @param {object} props
 * @param {string} props.target Target id.
 * @param {string} props.label
 * @param {string} [props.description] `Used by "…"` text, when the target is taken.
 * @param {boolean} props.selected
 * @param {(target: string) => void} props.onSelect
 */
function MappingTargetOption({ target, label, description, selected, onSelect }) {
  const menu = useDropdownMenu();
  const handleClick = useCallback(() => {
    onSelect(target);
    menu?.close?.();
  }, [onSelect, target, menu]);

  return (
    <MenuItem
      label={label}
      description={description}
      subtextMenu={Boolean(description)}
      disabled={Boolean(description)}
      selected={selected}
      size="small"
      onClick={handleClick}
    />
  );
}

export default memo(MappingTargetOption);
